import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { ReadSpeakerService } from '../../../services/readspeaker.service';
import { filter } from 'rxjs/operators';
import { WordingPipe } from '../../../pipes/wording/wording.pipe';

@Component({
  selector: 'shared-read-speaker',
  templateUrl: './button-launcher-read-speaker.component.html',
  styleUrls: ['./button-launcher-read-speaker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [WordingPipe],
})
export class ButtonLauncherReadSpeakerComponent implements AfterViewInit {
  private _readSpeakerService = inject(ReadSpeakerService);
  private _cdr = inject(ChangeDetectorRef);
  @Input() readonly idButtonDom: string;
  @Input() readonly targetIdToRead: string;
  @Input() readonly targetTypeToRead: 'id' | 'class' = 'id';
  isVisible = false;
  urlReadSpeaker = '';

  ngAfterViewInit(): void {
    this._readSpeakerService.hasAccess$.pipe(filter(val => val)).subscribe(() => {
      this.urlReadSpeaker = this._readSpeakerService.readSpeakerUrl(this.targetTypeToRead, this.targetIdToRead);
      this._cdr.detectChanges();
    });
    this._readSpeakerService.visibility$.subscribe(val => {
      this.isVisible = val;
      this._cdr.detectChanges();
      if (val) {
        this._readSpeakerService.enableTools(this.idButtonDom);
      }
    });
  }
}
